import { render } from "./windgramPage.vue?vue&type=template&id=7a284916"
import script from "./windgramPage.vue?vue&type=script&lang=js"
export * from "./windgramPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__